import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { Box, Typography } from "@mui/material";
import EMPButton from "../../shared/components/EMPButton/EMPButton";
import MotionChevronRightCircle from "../../shared/Icons/MotionChevronRightCircle";
import styles from "./ProtectionPlansMenuConfigAccordion.module.scss";

const ProtectionPlansMenuConfigAccordion = () => {
  const { t } = useTranslation();

  return (
    <Box
      className={styles.container}
      data-testid="protection-plans-menu-config-accordion"
    >
      <Typography variant="body1" className={styles.copy}>
        {t(
          "DealerOnboarding.content.protectionPlans.menuConfig.providerListDescription"
        )}
      </Typography>

      <EMPButton
        href={t(
          "DealerOnboarding.content.protectionPlans.menuConfig.providerListButtonURL"
        )}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.actionButton}
        testId="route-one-menu-provider-list-button"
        variant="outlined"
        hasRightIcon
        rightIcon={<MotionChevronRightCircle />}
      >
        {t(
          "DealerOnboarding.content.protectionPlans.menuConfig.providerListButtonLabel"
        )}
      </EMPButton>

      <Typography variant="body1" className={styles.copy}>
        <Trans
          i18nKey="DealerOnboarding.content.protectionPlans.menuConfig.configFormDescription"
          components={{ bold: <strong /> }}
        />
      </Typography>

      <EMPButton
        href={t(
          "DealerOnboarding.content.protectionPlans.menuConfig.configFormButtonURL"
        )}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.actionButton}
        testId="route-one-menu-config-form-button"
        variant="outlined"
        hasRightIcon
        rightIcon={<MotionChevronRightCircle />}
      >
        {t(
          "DealerOnboarding.content.protectionPlans.menuConfig.configFormButtonLabel"
        )}
      </EMPButton>

      <Typography variant="body1" className={styles.supportCopy}>
        {t(
          "DealerOnboarding.content.protectionPlans.menuConfig.supportDescription"
        )}
      </Typography>
    </Box>
  );
};

export default ProtectionPlansMenuConfigAccordion;
